import { useState, useEffect } from 'react'

// Probes whether Venmo is eligible (browser/device check) using the
// shared SDK loaded by usePaypalSdk. Doesn't load the SDK itself —
// keeping all loadScript calls in one place is what prevents
// @paypal/paypal-js from re-injecting its script and destroying live
// zoid components mid-flight.
const useVenmo = ({ paypalSdk }) => {
  const [ eligible, setEligible ] = useState(false)

  useEffect(() => {
    if (!paypalSdk) return
    setEligible(
      paypalSdk.Buttons({ fundingSource: paypalSdk.FUNDING.VENMO }).isEligible()
    )
  }, [ paypalSdk ])

  return { eligible }
}

export default useVenmo
